<pace-core-tree [model]="model" [parentForm]="treeViewForm" (nodeSelected)="onSelect($event)"></pace-core-tree>
